import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Houdt bij of de zijbalk ingeklapt is.
 *
 * De zijbalk (280px) en de pagina ernaast zijn twee losse componenten: de
 * balk staat vast links, de pagina houdt daar met een marge rekening mee.
 * Allebei moeten ze dus van dezelfde schakelaar weten, vandaar een dienst en
 * geen veld in één van beide.
 *
 * De keuze wordt onthouden. Wie de balk inklapt doet dat om ruimte te maken
 * voor een breed overzicht (het vlootoverzicht heeft tien kolommen); dan is
 * het hinderlijk als hij bij de volgende pagina weer openstaat.
 */
@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private static readonly SLEUTEL = 'sidebar-ingeklapt';

  private readonly _ingeklapt = new BehaviorSubject<boolean>(false);

  constructor(private localStorage: LocalStorageService) {
    this._ingeklapt.next(this.localStorage.retrieve(SidebarService.SLEUTEL) === true);
  }

  /** Voor de sjablonen: klapt mee zodra de schakelaar omgaat. */
  public get ingeklapt$(): Observable<boolean> {
    return this._ingeklapt.asObservable();
  }

  /** Voor code die de huidige stand nodig heeft zonder abonnement. */
  public get ingeklapt(): boolean {
    return this._ingeklapt.value;
  }

  public wissel(): void {
    this.zet(!this._ingeklapt.value);
  }

  public zet(ingeklapt: boolean): void {
    this._ingeklapt.next(ingeklapt);
    this.localStorage.store(SidebarService.SLEUTEL, ingeklapt);
  }
}
